import { Box } from '@mui/material';

export const StatusCardWrapper = ({
  children,
  borderColor,
}: React.PropsWithChildren<{
  borderColor: string;
}>) => {
  return (
    <Box
      padding={'24px 0'}
      border={'2px solid transparent'}
      borderRadius={'16px'}
      sx={{
        background: `linear-gradient(var(--mui-palette-background-paper) 0 0) padding-box,  ${borderColor} border-box`,
      }}
    >
      {children}
    </Box>
  );
};
